import {IconButton, Text, Theme} from '@smart/react-components';
import * as React from 'react';
import styles from './dialog.module.scss';

export type DialogProps = React.PropsWithChildren<{
  readonly headline: string | undefined;
  readonly closeButtonLabel: string | undefined;
  readonly headerRef?: React.Ref<HTMLElement>;
  readonly onClose: () => void;
}>;

export const Dialog = React.forwardRef<HTMLDialogElement, DialogProps>(
  (
    {headline, closeButtonLabel = `Close`, headerRef, children, onClose},
    ref,
  ) => {
    return (
      <Theme theme={`light`} asChild>
        <dialog className={styles.dialog} ref={ref}>
          <header className={styles.header} ref={headerRef}>
            <div className={styles.headerTop}>
              <Text className={styles.headline} variant="hl-300">
                {headline}
              </Text>

              <IconButton
                variant="ghost"
                aria-label={closeButtonLabel}
                onClick={onClose}
              >
                <IconButton.Icon icon={`close-without-circle`} />
              </IconButton>
            </div>
          </header>

          <div className={styles.main}>{children}</div>
        </dialog>
      </Theme>
    );
  },
);
